import { render } from "./hot.vue?vue&type=template&id=117cf660&scoped=true&ts=true"
import script from "./hot.vue?vue&type=script&lang=ts"
export * from "./hot.vue?vue&type=script&lang=ts"

import "./hot.vue?vue&type=style&index=0&id=117cf660&lang=less"
import "./hot.vue?vue&type=style&index=1&id=117cf660&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117cf660"]])

export default __exports__